import { Component } from '@ribajs/core'
import { isInMarketAllowlist, redirectToPath } from '../utils'

/**
 * A page component contains page content
 */
export class SbPageComponent extends Component {
  public static tagName = 'sb-page'

  public scope = {
    allowedMarkets: [] as string[],
    isDetail: false,
  }

  static get observedAttributes(): string[] {
    return ['allowed-markets', 'is-detail']
  }

  protected connectedCallback() {
    super.connectedCallback()
    this.init(SbPageComponent.observedAttributes)
  }

  async beforeBind() {
    // Redirect to 404 / remove the page if the current market is not in the allowlist
    if (!isInMarketAllowlist(this.scope.allowedMarkets)) {
      this.remove()
      if (this.scope.isDetail) {
        redirectToPath('404')
      }
    }
    await super.beforeBind()
  }

  protected template() {
    return null
  }
}
